var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, ViewChild, Input, Inject } from '@angular/core';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { ElementSettingModalBase } from '../base/element-setting-modal-base';
import { CalibrationGoModelToDataUtil } from '../shared/calibration-mark/calibration-go-model-to-data-util';
import { CalibrationDataToGoModelUtil } from '../shared/calibration-mark/calibration-data-to-go-model-util';
import { MeterConst } from './meter-const';
import { WordExceptBHDataType } from '../../core/variable/flag-data-type';
import { VariableName } from '../../core/variable/variable-name';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
import { VARIABLE_SERVICE } from '../../core/variable/variable.service';
var MeterSettingModalComponent = /** @class */ (function (_super) {
    __extends(MeterSettingModalComponent, _super);
    function MeterSettingModalComponent(injector, variableService, dataTypeService) {
        var _this = _super.call(this, injector, 'meterSettingModal') || this;
        _this.variableService = variableService;
        _this.dataTypeService = dataTypeService;
        _this.dataType = WordExceptBHDataType;
        return _this;
    }
    Object.defineProperty(MeterSettingModalComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(this._currentVariableId, v)) {
                return;
            }
            this._currentVariableId = v;
            this.currentVariableIdChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeterSettingModalComponent.prototype, "currentVariable", {
        get: function () {
            return this._currentVariable;
        },
        set: function (v) {
            if (v === this._currentVariable) {
                return;
            }
            this._currentVariable = v;
            this.validateMinMaxValue();
        },
        enumerable: true,
        configurable: true
    });
    MeterSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        this.configureId = editedComponent.configureId;
        if (this.currentEditedPartData.variableVersion) {
            this.currentVariableId = VariableName.tryParse(this.currentEditedPartData.variableName, this.currentEditedPartData.variableVersion);
        }
        else if (!_.isNil(this.currentEditedPartData.dataSourceCode)) {
            this.variableService.getVariableName(this.currentEditedPartData.dataSourceCode, this.currentEditedPartData.variableName, this.currentEditedPartData.variableGroupName).subscribe(function (value) {
                _this.currentVariableId = value;
            });
        }
        this.addCompatibility(editedComponent.model.data);
        this.calibrationData = new CalibrationGoModelToDataUtil(editedComponent.model.data).toViewData();
        this.loadMeterData(editedComponent.model.data);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        this.loadDynamicSetting(editedComponent.model.data);
        this.modal.show();
    };
    MeterSettingModalComponent.prototype.validateMinValue = function () {
        if (_.isNil(this.min)) {
            this.min = 0;
            return;
        }
        if (this.currentVariable) {
            if (this.currentVariable.dataType) {
                var dataTypeMinValue = this.dataTypeService.getMinValue(this.currentVariable.dataType);
                this.min = this.min < dataTypeMinValue ? dataTypeMinValue : this.min;
            }
        }
    };
    MeterSettingModalComponent.prototype.validateMaxValue = function () {
        if (_.isNil(this.max)) {
            this.max = 0;
            return;
        }
        if (this.currentVariable) {
            if (this.currentVariable.dataType) {
                var dataTypeMaxValue = this.dataTypeService.getMaxValue(this.currentVariable.dataType);
                this.max = this.max > dataTypeMaxValue ? dataTypeMaxValue : this.max;
            }
        }
    };
    MeterSettingModalComponent.prototype.validateMinMaxValue = function () {
        if (this.currentVariable && this.currentVariable.dataType) {
            var dataTypeMaxValue = this.dataTypeService.getMaxValue(this.currentVariable.dataType);
            this.max = this.max > dataTypeMaxValue ? dataTypeMaxValue : this.max;
            var dataTypeMinValue = this.dataTypeService.getMinValue(this.currentVariable.dataType);
            this.min = this.min < dataTypeMinValue ? dataTypeMinValue : this.min;
        }
    };
    MeterSettingModalComponent.prototype.addCompatibility = function (goModel) {
        if (goModel.showScale) {
            if (!goModel.hasOwnProperty('showCalibrationDigit')) {
                goModel.showCalibrationDigit = true;
                goModel.calibrationColor = MeterConst.defaultCalibrationColor;
                if (!goModel.hasOwnProperty('integerDigits')) {
                    goModel.integerDigits = MeterConst.defaultIntegerDigits;
                }
                if (!goModel.hasOwnProperty('fractionDigits')) {
                    goModel.fractionDigits = MeterConst.defaultFractionDigits;
                }
                goModel.calibrationDigitFontStyle = MeterConst.defaultCalibrationDigitFontStyle;
                goModel.calibrationDigitColor = MeterConst.defaultCalibrationDigitColor;
            }
        }
    };
    MeterSettingModalComponent.prototype.currentVariableIdChanged = function () {
        var _this = this;
        var variableId = this.currentVariableId;
        if (variableId && variableId.name) {
            this.isLoading = true;
            this.variableService.findVariable(variableId)
                .pipe(finalize(function () {
                _this.isLoading = false;
            }))
                .subscribe(function (variable) {
                _this.currentVariable = variable;
            });
        }
        else {
            this.currentVariable = undefined;
        }
    };
    MeterSettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    MeterSettingModalComponent.prototype.loadMeterData = function (componentData) {
        this.max = componentData.max;
        this.min = componentData.min;
    };
    MeterSettingModalComponent.prototype.validate = function () {
        return true;
    };
    MeterSettingModalComponent.prototype.save = function () {
        if (!this.validate()) {
            return;
        }
        this.saving = true;
        this.currentDiagram.startTransaction('meter settings');
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(1);
            return;
        }
        new CalibrationDataToGoModelUtil(this.currentDiagram, this.currentEditedPartData).saveToGoJsModel(this.calibrationData);
        this.saveComponentProperty('min', this.min);
        this.saveComponentProperty('max', this.max);
        this.deleteComponentProperty('dataSourceCode');
        this.deleteComponentProperty('variableGroupName');
        this.saveComponentProperty('variableName', this.currentVariableId ? this.currentVariableId.name : '');
        this.saveComponentProperty('variableVersion', this.currentVariableId ? this.currentVariableId.variableVersion : undefined);
        this.saveComponentProperty('variableDataType', this.currentVariable ? this.currentVariable.dataType : '');
        this.saveDynamicSetting();
        this.currentDiagram.commitTransaction('meter settings');
        this.close();
    };
    MeterSettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    MeterSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    MeterSettingModalComponent.prototype.onHidden = function () {
        this.currentVariableId = undefined;
        _super.prototype.onHidden.call(this);
    };
    MeterSettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], MeterSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], MeterSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        Input()
    ], MeterSettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], MeterSettingModalComponent.prototype, "viewHeight", void 0);
    MeterSettingModalComponent = __decorate([
        Component({
            selector: 'meter-setting-modal',
            styles: [".configure.meter{ .checkbox { padding-left: 20px; } .form-control{ width:100%; } } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"meterSettingModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" (onHidden)=\"onHidden()\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\" style=\"min-width: 600px;\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <form class=\"configure meter\" *ngIf=\"active\" #textAttributeForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc('Meter')}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-content\"> <div class=\"clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"MinimumValue\")}}</div> <input type=\"number\" class=\"fe-vertical-input\" name=\"graduatedMin\" [(ngModel)]=\"min\" (change)=\"validateMinValue()\" required> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"MaximumValue\")}}</div> <input type=\"number\" class=\"fe-vertical-input\" name=\"graduatedMax\" [(ngModel)]=\"max\" (change)=\"validateMaxValue()\" required> </div> </div> <div class=\"fe-vertical-label help-block text-danger\" *ngIf=\"min>=max\"> <div class=\"fe-vertical-title\">{{lc(\"MaximumMinimumValidateInfo\")}}</div> </div> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(\"VariableName\")}}:</div> <div class=\"fe-vertical-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> </div> </tab> <tab heading=\"{{lc('CalibrationAndMarker')}}\"> <calibration-mark [data]=\"calibrationData\"></calibration-mark> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true' [isSameSize]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"textAttributeForm.invalid || min>=max || dynamicValidatoinResult\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        }),
        __param(1, Inject(VARIABLE_SERVICE))
    ], MeterSettingModalComponent);
    return MeterSettingModalComponent;
}(ElementSettingModalBase));
export { MeterSettingModalComponent };
